import { useQuery } from "@tanstack/react-query";
import { API_SPECIAL } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetSpecial = <T>(params: { [key: string]: string }, options = {}) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_SPECIAL_INFO, params],
        queryFn: () => API_SPECIAL.getSpecialInfo<T>(params),
        ...options,
    });

    return { data, isLoading };
};
